// stores/filter.ts
import { defineStore } from 'pinia'

export const useFilterStore = defineStore('filter', {
  state: () => ({
    strict: 0 as number, // default mode (Ouvert)
    filters: [] as number[], // default filters
  }),
  actions: {
    setStrict(value: number) {
      this.strict = value
    },
    setFilters(values: number[]) {
      this.filters = values
    },
  },
  persist: true,
})
